export const ALLOWED_FILE_TYPES = [
  "image/jpeg",
  "image/jpg",
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel", //XLS
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", //XLSX
  "application/vnd.ms-excel.sheet.macroenabled.12", //XLSM
  "image/png",
  "image/webp",
  "image/heic",
  "image/heif",
];

export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
